import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["scrollable"];

  scrollLeft() {
    this.scroll(-1);
    this.toggleButtonBorders();
  }

  scrollRight() {
    this.scroll(1);
    this.toggleButtonBorders();
  }

  scroll(direction) {
    const scrollAmount = this.scrollableTarget.clientWidth * 0.8; // Adjust scroll step as needed
    this.scrollableTarget.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  }

  toggleButtonBorders() {
    const isAtStart = this.scrollableTarget.scrollLeft === 0;
    const isAtEnd = this.scrollableTarget.scrollLeft + this.scrollableTarget.clientWidth >= this.scrollableTarget.scrollWidth;

    const leftButton = this.element.querySelector('[data-action="click->scroll#scrollLeft"]');
    const rightButton = this.element.querySelector('[data-action="click->scroll#scrollRight"]');
    let classToToggle = "border-gray-200";
    if (this.element.id == "explore-stays") {
      classToToggle = "nav-button-active";
    } else if (this.element.id == "exclusive-heritage-experiences") {
      classToToggle = "bg-black";
    }

    if (isAtStart) {
      leftButton.classList.remove(classToToggle);
    } else {
      leftButton.classList.add(classToToggle);
    }

    if (isAtEnd) {
      rightButton.classList.remove(classToToggle);
    } else {
      rightButton.classList.add(classToToggle);
    }
  }
}